import { render, staticRenderFns } from "./MeterRecordSetting.component.vue?vue&type=template&id=0928a72a&scoped=true"
import script from "./MeterRecordSetting.component.vue?vue&type=script&lang=js"
export * from "./MeterRecordSetting.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0928a72a",
  null
  
)

export default component.exports